// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegenerateAiSuggestionsV2ForTargetMutationVariables = Types.Exact<{
  input: Types.RegenerateAiSuggestionsV2ForTargetInput;
}>;


export type RegenerateAiSuggestionsV2ForTargetMutation = { __typename?: 'Mutation', regenerateAISuggestionsV2ForTarget: boolean };

export const Operations = {
  Mutation: {
    RegenerateAISuggestionsV2ForTarget: 'RegenerateAISuggestionsV2ForTarget' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const RegenerateAiSuggestionsV2ForTargetDocument = gql`
    mutation RegenerateAISuggestionsV2ForTarget($input: RegenerateAISuggestionsV2ForTargetInput!) {
  regenerateAISuggestionsV2ForTarget(input: $input)
}
    `;
export type RegenerateAiSuggestionsV2ForTargetMutationFn = Apollo.MutationFunction<RegenerateAiSuggestionsV2ForTargetMutation, RegenerateAiSuggestionsV2ForTargetMutationVariables>;

/**
 * __useRegenerateAiSuggestionsV2ForTargetMutation__
 *
 * To run a mutation, you first call `useRegenerateAiSuggestionsV2ForTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateAiSuggestionsV2ForTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateAiSuggestionsV2ForTargetMutation, { data, loading, error }] = useRegenerateAiSuggestionsV2ForTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateAiSuggestionsV2ForTargetMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateAiSuggestionsV2ForTargetMutation, RegenerateAiSuggestionsV2ForTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateAiSuggestionsV2ForTargetMutation, RegenerateAiSuggestionsV2ForTargetMutationVariables>(RegenerateAiSuggestionsV2ForTargetDocument, options);
      }
export type RegenerateAiSuggestionsV2ForTargetMutationHookResult = ReturnType<typeof useRegenerateAiSuggestionsV2ForTargetMutation>;
export type RegenerateAiSuggestionsV2ForTargetMutationResult = Apollo.MutationResult<RegenerateAiSuggestionsV2ForTargetMutation>;
export type RegenerateAiSuggestionsV2ForTargetMutationOptions = Apollo.BaseMutationOptions<RegenerateAiSuggestionsV2ForTargetMutation, RegenerateAiSuggestionsV2ForTargetMutationVariables>;